import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';

import ViewWrapper from 'views/ViewWrapper';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
});

const Settings = props => {
  const { classes } = props;

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Settings
          </MuiTypography>
          <MuiTypography variant="body1">App settings will go here</MuiTypography>
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(Settings);
